import { ArrowRight, ArrowUpRight } from 'lucide-react'

import Button from '/react4xp/components/prototype/Button'

import type { VacanciesProps, VacancyRow } from './types'

export default function Vacancies({
	overline,
	title,
	intro,
	image,
	rows = [],
	viewAllLink,
	labels = {},
}: VacanciesProps) {
	const { applyNowLabel = 'Apply now', readMoreLabel = 'Read more' } = labels

	const hasViewAllLink = Boolean(viewAllLink?.text && viewAllLink?.url)

	const viewAllButton = hasViewAllLink && viewAllLink && (
		<Button variant="link" href={viewAllLink.url} isExternal={viewAllLink.isExternal}>
			{viewAllLink.text}
			{viewAllLink.isExternal ? (
				<ArrowUpRight className="h-lh w-5 shrink-0" aria-hidden="true" />
				) : (
				<ArrowRight className="h-lh w-5 shrink-0" aria-hidden="true" />
			)}
		</Button>
	)

	return (
		<section className="my-16">
			<div className="container">
				<div className="flex flex-col lg:flex-row gap-8">

					<div className="flex-1 min-w-0">
						<div className="flex items-start justify-between gap-8">
							<div className="flex flex-col">
								{overline && <p className="body text-black-950">{overline}</p>}
								{title && <h2 className="h2 text-black-950">{title}</h2>}
							</div>
						</div>

						{intro && <p className="body text-black-950 mt-6">{intro}</p>}

						{rows.length > 0 && (
							<div className="flex flex-col mt-8">
								{rows.map((row, i) => (
									<JobRow key={i} row={row} applyNowLabel={applyNowLabel} readMoreLabel={readMoreLabel} />
								))}
							</div>
						)}

						{hasViewAllLink && <span className="mt-8 flex lg:justify-end">{viewAllButton}</span>}
					</div>

					{image && (
						<div className="hidden lg:block flex-1 min-w-0">
							<figure className="w-full max-w-full h-130 rounded-xs overflow-hidden">
								<img src={image.src} alt={image.alt} className="w-full h-full object-cover" />
							</figure>
						</div>
					)}

				</div>
			</div>
		</section>
	)
}

function JobRow({
	row,
	applyNowLabel,
	readMoreLabel,
}: {
	row: VacancyRow
	applyNowLabel: string
	readMoreLabel: string
}) {
	return (
		<div className="flex flex-wrap items-center gap-3 py-2 border-b border-black-100">
			<h3 className="h5 text-black-950 flex-[1_0_0] min-w-86">{row.title}</h3>

			<div className="flex flex-wrap items-center gap-3 justify-end">
				{row.applicationUrl && (
					<Button variant="primary" size="sm" href={row.applicationUrl} isExternal>
						{applyNowLabel}
					</Button>
				)}
				<Button variant="link" href={row.readMoreUrl}>
					{readMoreLabel}
				</Button>
			</div>
		</div>
	)
}
